import { z } from 'zod';
import { firewallRuleFormSchema } from '#schemas/firewall-rule/index.ts';
import { tagNameSchema } from '#schemas/tag/name.ts';
import { configOverridesFieldSchema } from './config-overrides/config-overrides-field-schema.ts';

export const tagFormSchema = z.object({
  name: tagNameSchema,
  description: z.string(),
  configOverrides: configOverridesFieldSchema,
  routeSubscriptions: z.array(
    z.object({ routeId: z.string().refine((id): id is `route-${string}` => id.startsWith('route-')) })
  ),
  firewallRules: z.array(firewallRuleFormSchema),
});

export type TagFormData = z.infer<typeof tagFormSchema>;
